import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { OfferListFilters } from '@modules/offers/types';
import { IDropdownOptions } from '@shared/interface';

interface AppliedFiltersBarProps {
  filters: OfferListFilters;
  onRemove: (field: keyof OfferListFilters) => void;
  categoryOptions: IDropdownOptions[];
  currencyOptions: IDropdownOptions[];
  scopeOptions: IDropdownOptions[];
  countryOptions: IDropdownOptions[];
}

export const AppliedFiltersBar: React.FC<AppliedFiltersBarProps> = ({
  filters,
  onRemove,
  categoryOptions,
  currencyOptions,
  scopeOptions,
  countryOptions,
}) => {
  const renderChip = (label: string, field: keyof OfferListFilters) => (
    <Chip
      key={field}
      size="small"
      label={label}
      onDelete={() => onRemove(field)}
      sx={{ m: 0.5 }}
      color="primary"
      variant="outlined"
      style={{ textTransform: 'capitalize' }}
    />
  );

  const getLabel = (value: string | number, options: IDropdownOptions[]) => {
    const option = options.find((opt) => opt.optionId === value);
    return option?.label || String(value);
  };

  const statusLabelMap = {
    draft: 'Draft',
    staging: 'Sandbox',
    prod: 'Production',
  };

  const chips: React.ReactNode[] = [];
  if (filters.sync_on) {
    const statusLabel = statusLabelMap[filters.sync_on as keyof typeof statusLabelMap] || filters.sync_on;
    chips.push(renderChip(statusLabel, 'sync_on'));
  }
  if (filters.status) chips.push(renderChip(filters.status, 'status'));
  if (filters.category) chips.push(renderChip(getLabel(filters.category, categoryOptions), 'category'));
  if (filters.currency) chips.push(renderChip(getLabel(filters.currency, currencyOptions), 'currency'));
  if (filters.scope) chips.push(renderChip(getLabel(filters.scope, scopeOptions), 'scope'));
  if (filters.country) chips.push(renderChip(getLabel(filters.country, countryOptions), 'country'));
  // if (filters.dateFrom || filters.dateTo) {
  //   chips.push(
  //     renderChip(`Date: ${filters.dateFrom || '...'}${filters.dateTo ? ' ~ ' + filters.dateTo : ''}`, 'dateFrom'),
  //   );
  // }
  // Add other filter chips as needed

  return (
    <Box
      sx={{
        display: chips.length > 0 ? 'flex' : 'block',
        flexWrap: 'wrap',
        alignItems: 'center',
        py: 0.5,
        minHeight: 36,
      }}
    >
      {chips.length > 0 && (
        <Stack>
          <Typography sx={{ ml: 1, fontSize: 14, color: 'text.secondary' }}>Active Filters:</Typography>
          <Box>{chips}</Box>
        </Stack>
      )}
    </Box>
  );
};
